import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { UtilsService } from 'src/app/utils/utils.service';
import { isNullOrUndefined } from 'util';
import { DanaDataService } from '../../kolkata-event/dana-data.service';
import { KOLKATAEVENT_2025_TIMESTAMPLIST } from '../../kolkata-event/kolkata-event-map/kolkata-event-map-cnst';

@Component({
  selector: 'app-event-sidebar',
  templateUrl: './event-sidebar.component.html',
  styleUrls: ['./event-sidebar.component.scss']
})
export class EventSidebarComponent implements OnInit {

  selectedDate: any;
  sourceList = {
    IMD_RADAR_NOWCAST: 'IMD RADAR',
  }
  isInitialLoad: boolean = false;
  queryParams: any;
  selectedSource: any;
  timestampList: any;
  selectedTimestamp: any
  selected: any;

  constructor(private gisUtils: UtilsService, private route: ActivatedRoute, private router: Router, private danaDataSrv: DanaDataService) {
    const url = this.router.url;
    const urlparams = url.split('/');
    this.selected = urlparams[2];
  }

  ngOnInit() {
    this.route.queryParamMap.subscribe((params: Params) => {
      this.queryParams = {};
      for (const param in params) {
        if (params.hasOwnProperty(param)) {
          this.queryParams = params[param];
        }
      }
      if (!isNullOrUndefined(this.queryParams) && Object.keys(this.queryParams).length > 0) {
        this.isInitialLoad = true
        this.requestSelectedFilterParams()
        if (!this.isInitialLoad) {
          this.selectedSource = this.queryParams['source']
          // this.selectedDate = this.queryParams['date']
          this.setTimestampList()
          this.selectedTimestamp = this.queryParams['timeStamp']
        }
      }
    })
  }

  requestSelectedFilterParams() {
    let currentUrlParams: any = {};
    // if (!this.isInitialLoad) {
    //   currentUrlParams = this.selectedParams;
    // }
    currentUrlParams['component'] = 'KOLKATA2025EVENT';
    currentUrlParams['src'] = 'IMD_GRID'
    if (this.isInitialLoad) {
      currentUrlParams['actionType'] = 'filter';
      currentUrlParams['view'] = 'ADMIN';
      currentUrlParams['pType'] = 'COUNTRY';
      currentUrlParams['cType'] = 'STATE';
      currentUrlParams['parentLoc'] = 'COUNTRY';
      currentUrlParams['dashboardView'] = 'INDIA';
      this.gisUtils.selectedParams.next(currentUrlParams);
      this.isInitialLoad = false
    }
  }

  setTimestampList() {
    let timeStampList = KOLKATAEVENT_2025_TIMESTAMPLIST
    this.timestampList = this.convertTo24HourFormat(timeStampList)
  }

  convertAndSortTimestamps(timestamps: number[]): Record<string, number> {
    const sortedTimestamps = [...timestamps].sort((a, b) => a - b);
    const result: Record<string, number> = {};

    sortedTimestamps.forEach(ts => {
      const date = new Date(ts);

      const day = date.getDate();
      const month = date.toLocaleString('en-US', { month: 'long' });

      let hour = date.getHours();
      const minutes = date.getMinutes().toString().padStart(2, '0');
      const suffix = hour >= 12 ? 'PM' : 'AM';
      hour = hour % 12 || 12; // convert 0 to 12

      const label = `${day}${month} ${hour}:${minutes}${suffix}`;
      result[label] = ts;
    });

    return result;
  }

  convertAndSortTimestampsClockwise(timestamps: number[]): Record<string, number> {
  // const result: Record<string, number> = [];

  const formatted = timestamps.map(ts => {
    const date = new Date(ts);
    const hour24 = date.getHours();
    const minutes = date.getMinutes();
    const suffix = hour24 >= 12 ? 'PM' : 'AM';
    const hour12 = hour24 % 12 || 12;
    const minuteStr = minutes.toString().padStart(2, '0');

    return {
      ts,
      label: `${date.getDate()}${date.toLocaleString('en-US', { month: 'long' })} ${hour12}:${minuteStr}${suffix}`,
      clockOrder: ((hour12 % 12) + (suffix === 'PM' ? 12 : 0)) % 24, // 0 → 12AM, 1 → 1AM, ..., 23 → 11PM
      minutes,
    };
  });

  formatted.sort((a, b) => {
    if (a.clockOrder !== b.clockOrder) {
      return a.clockOrder - b.clockOrder;
    } else {
      return a.minutes - b.minutes; // sort by minute within hour
    }
  });

  const output: Record<string, number> = {};
  formatted.forEach(item => {
    output[item.label] = item.ts;
  });

  return output;
}

convertTo24HourFormat(timestamps: number[]): Record<string, number> {
  const getDayWithSuffix = (day: number): string => {
    if (day > 3 && day < 21) return day + 'th';
    switch (day % 10) {
      case 1: return day + 'st';
      case 2: return day + 'nd';
      case 3: return day + 'rd';
      default: return day + 'th';
    }
  };

  const formatted = timestamps.map(ts => {
    const date = new Date(ts);
    const dayWithSuffix = getDayWithSuffix(date.getDate());
    const month = date.toLocaleString('en-US', { month: 'long' });
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const label = `${dayWithSuffix} ${month} ${hours}:${minutes}`;
    return { label, ts };
  });

  // Sort by timestamp (chronologically)
  formatted.sort((a, b) => a.ts - b.ts);

  const result: Record<string, number> = {};
  formatted.forEach(({ label, ts }) => {
    result[label] = ts;
  });

  return result;
}

  // convertAndSortTimestamps(timestamps: number[]): Record<string, number> {
  //   // First sort by timestamp (chronological order)
  //   const sortedTimestamps = [...timestamps].sort((a, b) => a - b);

  //   const result: Record<string, number> = {};

  //   sortedTimestamps.forEach(ts => {
  //     const date = new Date(ts);

  //     const day = date.getDate();
  //     const month = date.toLocaleString('en-US', { month: 'long' });

  //     let hour = date.getHours();
  //     const suffix = hour >= 12 ? 'PM' : 'AM';
  //     hour = hour % 12 || 12; // 0 becomes 12

  //     const label = `${day}${month} ${hour}${suffix}`;
  //     result[label] = ts;
  //   });

  //   return result;
  // }

  onSubmit() {
    let options = { ...this.queryParams }
    options['timeStamp'] = this.selectedTimestamp
    options['source'] = this.selectedSource
    this.router.navigate(['/nowcastweather/kolkata2025/akbm'], {
      relativeTo: this.route,
      queryParams: options,
      queryParamsHandling: 'merge'
    });
  }


}
